(function () {
  var featuredProductSwipers = {};

  function destroyFeaturedProducts(sectionId) {
    if (featuredProductSwipers[sectionId]) {
      featuredProductSwipers[sectionId].destroy(
        true,
        true
      );

      delete featuredProductSwipers[sectionId];
    }
  }

  function initFeaturedProducts(sectionId) {
    var sectionEl = document.getElementById(
      'section-' + sectionId
    );

    if (!sectionEl) {
      return;
    }

    var swiperEl = sectionEl.querySelector(
      '.featured-products__swiper'
    );

    var prevButton = sectionEl.querySelector(
      '.featured-products__arrow--prev'
    );

    var nextButton = sectionEl.querySelector(
      '.featured-products__arrow--next'
    );

    var paginationEl = sectionEl.querySelector(
      '.featured-products__pagination'
    );

    var mobileColumns =
      parseInt(
        sectionEl.getAttribute('data-mobile-columns'),
        10
      ) || 2;

    if (!swiperEl) {
      return;
    }

    if (window.innerWidth >= 750) {
      destroyFeaturedProducts(sectionId);
      return;
    }

    if (typeof Swiper === 'undefined') {
      return;
    }

    destroyFeaturedProducts(sectionId);

    featuredProductSwipers[sectionId] =
      new Swiper(swiperEl, {
        slidesPerView: mobileColumns,
        slidesPerGroup: mobileColumns,
        spaceBetween: 12,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,

        navigation: {
          prevEl: prevButton,
          nextEl: nextButton
        },

        pagination: {
          el: paginationEl,
          clickable: true,
          dynamicBullets: false
        }
      });
  }

  function initializeAllFeaturedProducts() {
    var sections = document.querySelectorAll(
      '.featured-products[data-section-id]'
    );

    if (!sections.length) {
      return;
    }

    function run() {
      sections.forEach(function (sectionEl) {
        var sectionId = sectionEl.getAttribute(
          'data-section-id'
        );

        initFeaturedProducts(sectionId);
      });
    }

    if (typeof Swiper !== 'undefined') {
      run();
    } else {
      document.addEventListener(
        'swiper:ready',
        run,
        { once: true }
      );
    }
  }

  var resizeTimer;

  function handleResize() {
    window.clearTimeout(resizeTimer);

    resizeTimer = window.setTimeout(function () {
      initializeAllFeaturedProducts();
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllFeaturedProducts
    );
  } else {
    initializeAllFeaturedProducts();
  }

  window.addEventListener('resize', handleResize);

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      var sectionEl = event.target.querySelector(
        '.featured-products[data-section-id]'
      );

      if (!sectionEl) {
        return;
      }

      var sectionId = sectionEl.getAttribute(
        'data-section-id'
      );

      if (typeof Swiper !== 'undefined') {
        initFeaturedProducts(sectionId);
      } else {
        document.addEventListener(
          'swiper:ready',
          function () {
            initFeaturedProducts(sectionId);
          },
          { once: true }
        );
      }
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      var sectionEl = event.target.querySelector(
        '.featured-products[data-section-id]'
      );

      if (!sectionEl) {
        return;
      }

      var sectionId = sectionEl.getAttribute(
        'data-section-id'
      );

      destroyFeaturedProducts(sectionId);
    }
  );
})();
